import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpClientExtension } from '../../../common/services/http-client-extension.service';

import { LoginAdSliderList } from './login-ad-slider.model';


@Injectable({providedIn: 'root'})
export class LoginAdSliderService {

	constructor(
		private http: HttpClientExtension,
	) { }

	public getAdSliders(): Observable<LoginAdSliderList> {
		return this.http.get<LoginAdSliderList>('rest/common/pre-login/banners');
	}

}
